import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../app/_services/auth.service';
import { TogglePanelCallback } from '../custom/components/toggle-panel.component';
import { ConfirmModal } from '../custom/services/confirm-modal.service';
import { ErrorHandlerService } from '../custom/services/error-handler.service';
import { Growl } from '../custom/services/growl.service';
import { SsoSettingsResource } from '../resources/sso-settings.resource';

@Component({
    selector: 'pkp-storage-admin-prisma-credit-limit-check',
    template: require('./storage-admin-prisma-credit-limit-check.component.html')
})
export class StorageAdminPrismaCreditLimitCheckComponent implements OnInit {
    creditLimitCheckEnabled: boolean;
    authUser: LoginResult;
    creditLimitCheckSetting: StorageCreditLimitCheckSettingDto;
    loading: boolean = true;
    loadingFrameworks: boolean = true;
    showCreateFrameworkForm: boolean = false;

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private authService: AuthService,
        private errorHandlerService: ErrorHandlerService,
        private growl: Growl,
        private confirmModal: ConfirmModal
    ) {}

    ngOnInit(): void {
        this.loading = true;
        this.fetchCreditLimitsCheckSetting();
    }

    fetchCreditLimitsCheckSetting() {
        this.loadingFrameworks = true;
        this.authService.userLoginPromise.promise.then((res) => {
            this.authUser = res;
            this.ssoSettingsResource
                .fetchCreditLimitCheckSetting(this.authUser.referenceId)
                .pipe(finalize(() => (this.loading = false)))
                .subscribe((res) => {
                    this.creditLimitCheckEnabled = res != null;
                    this.creditLimitCheckSetting = res;
                    this.loadingFrameworks = false;
                });
        });
    }

    toggleCreditLimitCheck($event: TogglePanelCallback) {
        this.ssoSettingsResource
            .toggleCreditLimitCheckSetting(
                this.authUser.referenceId,
                this.creditLimitCheckEnabled
            )
            .subscribe(
                (res) => {
                    $event(true);
                    this.creditLimitCheckEnabled = res;
                    if (this.creditLimitCheckEnabled) {
                        this.fetchCreditLimitsCheckSetting();
                    }
                },
                (err) => {
                    $event(false);
                    this.errorHandlerService.handle(
                        err,
                        'Could not change credit limit setting.'
                    );
                }
            );
    }

    deleteCreditFramework(identifier: string, id: number) {
        this.confirmModal
            .fromText(
                `Do you really want to delete the credit framework “${identifier}”?`
            )
            .subscribe((confirm) => {
                if (!confirm) return;

                this.ssoSettingsResource
                    .deleteCreditFramework(this.authUser.referenceId, id)
                    .subscribe(() => {
                        this.growl.show(
                            'Successfully deleted credit framework.',
                            'success'
                        );
                        this.creditLimitCheckSetting.frameworks.splice(
                            this.creditLimitCheckSetting.frameworks.findIndex(
                                (f) => f.id === id
                            ),
                            1
                        );
                    }, this.errorHandlerService.handle.bind(this));
            });
    }

    onFrameworkCreated(framework: StorageFrameworkDto) {
        this.creditLimitCheckSetting.frameworks.push(framework);
        this.showCreateFrameworkForm = false;
    }

    onFrameworkUpdated(framework: StorageFrameworkDto) {
        this.creditLimitCheckSetting.frameworks[
            this.creditLimitCheckSetting.frameworks.findIndex(
                (f) => f.id === framework.id
            )
        ] = framework;
    }
}
